<template>
  <div class="systematic-detail">
    <div class="scroll" :loaded="loaded" ref="scroll">
      <div>
        <div v-show="loaded">
          <div class="home">
            <router-link tag="span" to="/index">
              <i class="iconfont icon-home"></i>返回首页
            </router-link>
            <a href="https://www.wjx.top/jq/30293001.aspx" class="zixun">
              <i class="iconfont icon-winfo-icon-fankuiwenti"></i>问题反馈
            </a>
          </div>
          <div class="list-head">
            <img :src="detail.avatar" alt />
            <!-- <div class="title">
              <div class="name">{{detail.course_title}}</div>
            </div>-->
          </div>
          <!-- 折扣一口价倒计时 vip就忽略这个促销信息 -->
          <free-countdown
            v-if="!user.isvip && (detail.promotion_type === 2 || detail.promotion_type === 3)"
            :end="detail.promotion_enddate"
          ></free-countdown>
          <!-- 标题栏 -->
          <div class="big-title-wrap">
            <div class="big-title">
              <p>
                <span v-if="detail.istop">精品课</span>
                {{ detail.course_title }}
              </p>
              <div class="price">
                <!-- 没有购买 -->
                <template v-if="!detail.is_buy">
                  <!-- vip了 显示vip打折图标 -->
                  <img
                    src="~common/image/vip-label-1.png"
                    alt
                    class="vip-label-1"
                    v-if="user.isvip"
                  />
                  <!-- 打折或者 一口价 -->
                  <template
                    v-if="detail.promotion_type === 2 || detail.promotion_type === 3 || detail.promotion_type === 4"
                  >
                    <!-- 促销就用促销价格 -->
                    <span class="n">￥{{ detail.promotion_price }}</span>
                    <s class="o">￥{{ detail.price }}</s>
                  </template>
                  <!-- 限时免费 -->
                  <template v-else-if="detail.promotion_type === 1">
                    <span class="f">限时免费</span>
                    <s class="o">￥{{ detail.price }}</s>
                  </template>
                  <!-- 没有活动 显示原价 -->
                  <template v-else>
                    <span class="n">￥{{ detail.price }}</span>
                  </template>
                </template>
                <!-- 已购买就显示学了多久了 -->
                <template v-else>
                  <span class="b" v-if="!detail.is_complete">已学习{{ detail.study_time }}分钟</span>
                  <span class="b" v-else>已完成学习</span>
                </template>
                <!-- 右侧的赞 -->
                <!-- <span class="zan"><i class="iconfont icon-zan"></i> {{detail.goods||0}}</span> -->
                <span class="zan">评分 {{ detail.stars }}</span>
              </div>
            </div>
            <!-- 助力活动 是vip就不显示-->
            <zhuli
              :zhuliData="zhuliData"
              :kcData="detail"
              v-if="detail.is_assistance === 1 && !user.isvip"
            ></zhuli>
            <get-vip v-else-if="!user.isvip && !detail.is_buy"></get-vip>
            <!-- 没有助力 且不是 vip 并且没买提醒去开通vip-->
          </div>
          <con-tab class="border-bottom">
            <router-link tag="div" to="intro" class="tab" replace>课程详情</router-link>
            <router-link tag="div" to="playlist" class="tab" replace>
              目录
              <!-- ({{detail.videoList.length}}) -->
            </router-link>
          </con-tab>
          <!-- <div class="nav2">
            <div class="col col-1">{{navTitle}}</div>
            <div class="col col-2">
              <span><i class="iconfont icon-weibiaoti4"></i> {{detail.browses}}</span>
              <span><i class="iconfont icon-zan"></i> {{detail.goods}}</span>
            </div>
          </div>-->
          <div class="content">
            <keep-alive>
              <router-view
                :con="detail.content"
                :detail="detail"
                @refreshScroll="refreshScroll"
                @setNavTitle="setNavTitle"
              ></router-view>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载动画 -->
    <loading v-show="!loaded"></loading>
    <!-- 立即购买 -->
    <div class="buy" v-show="loaded">
      <div>
        <div class="col col-1" @click="collect">
          <i
            class="iconfont"
            :class="{ 'icon-shoucang': !detail.is_collection, 'icon-yishoucang': detail.is_collection }"
          ></i>
          收藏
          <!-- <template v-if="!detail.is_promotion">价格: ¥{{detail.price}}</template>
          <template v-if="detail.is_promotion"><s>价格: {{detail.price}}</s>&emsp;<span>¥{{detail.promotion_price}}</span></template>-->
        </div>
        <template v-if="detail.is_buy">
          <!-- 完成学习了 可以查看证书 -->
          <div
            class="col col-2"
            v-if="detail.is_complete && detail.cert"
            @click="goCert(detail.cert)"
          >查看证书</div>
          <div class="col col-2" v-else-if="detail.is_complete">已完成学习</div>
          <div class="col col-2 disabled" v-else>未完成学习</div>
        </template>
        <div class="col col-2" @click="buy" v-else>立即购买</div>
      </div>
    </div>
    <!-- 分销按钮 -->
    <div class="zhuan" v-if="isWeixin">
      <div>
        <router-link
          tag="div"
          :to="{ name: 'fenxiao', params: { url: url, courseId: detail.course_id, courseTitle: detail.course_title } }"
          v-if="detail.is_distribution"
        >
          <div class="col col-1">
            <i class="iconfont icon-renminbi"></i>
          </div>
          <div class="col col-2">
            <span>
              赚
              <span v-if="detail.show_share_price">{{ detail.share_price }}元</span>
            </span>
          </div>
        </router-link>
      </div>
    </div>
    <qr-popup class="qr-popup" :show="showQrPopup" :img="qrurl" :text="qrtext"></qr-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import Loading from 'components/base/loading/loading.vue'
import Scroll from '../base/scroll/scroll'
import { RES_OK } from '@/api/config'
import { getTxDetail } from '@/api/tixike.js'
import config from '@/utils/config.js'
import { coursePageShare, ChannelHaoYou, ChannelPengYouQuan } from '@/api/user-behavior.js'
import { wxShare, currentHref, zhuliShareConfig } from '../../api/wx-share.js'
import { mapGetters } from 'vuex'
import Zhuli from 'components/base/activity/zhuli/zhuli'
import { getZhuli } from '@/api/activity/zhuli.js'
import { collectCourse } from '@/api/user-behavior'
import ConTab from 'components/base/ui/course-tab'
import FreeCountdown from 'components/base/ui/free-countdown'
import GetVip from 'components/base/ui/get-vip'
import QrPopup from 'components/base/qr-popup'
export default {
  components: {
    Loading,
    Scroll,
    Zhuli,
    ConTab,
    FreeCountdown,
    GetVip,
    QrPopup
  },
  data() {
    return {
      detail: {
        videoList: []
      },
      loaded: false,
      url: currentHref(),
      navTitle: '',
      zhuliData: {
        // asist_user_avatar: require('common/image/avatar.png'),
        // course_title: '我是标题我是标题我是标题我是标题',
        // 剩余多少人可以解锁
        // left_user_count: 3,
        // join_user_avatar: [require('common/image/avatar.png'), require('common/image/avatar.png')],
        // 是否已经助力成功 2：完成助力 1：未完成 0：隐藏不显示
        // is_ended: 1,
        // end_time_seconds
        // end_time_seconds: 100000
      },
      collecting: false, // 防止用户快点收藏按钮
      // 收藏二维码弹框
      showQrPopup: false,
      qrurl: '',
      qrtext: ''
    }
  },
  computed: {
    ...mapGetters({
      isWeixin: 'isWeixin'
    }),
    ...mapGetters(['user'])
  },
  mounted() {
  },
  created() {
    getTxDetail(this.$route.params.id).then((res) => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        // 如果 islimitfree , 全部免费忽略 is_buy字段
        // 直接 当做已经购买过了
        if (data.data.islimitfree) {
          data.data.is_buy = true
        }
        this.detail = data.data
        this.loaded = true
        document.title = this.detail.course_title
        wxShare({
          success: () => {
            coursePageShare(this.detail.course_id, 0, ChannelHaoYou)
          }
        }, {
          success: () => {
            coursePageShare(this.detail.course_id, 0, ChannelPengYouQuan)
          }
        })
        // 获取助力活动参数
        let aaid = this.$route.query.aaid
        // 如果是助力活动, 获取助力活动信息
        if (this.detail.is_assistance === 1 && aaid) {
          // 修改分享信息
          wxShare(zhuliShareConfig(this.detail.numlimit))
          // 获取助力活动信息
          this._getZhuli(aaid)
        }
      }
    })
  },
  methods: {
    _getZhuli(aaid) {
      // 获取活动信息
      getZhuli(this.detail.course_id, this.detail.activity_id, aaid).then(res => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.zhuliData = data.data
        } else {
          let msg = data.msg || '系统异常'
          this.$toast(msg, {
            duration: 3500
          })
        }
      }).catch(err => {
        this.$toast(err.response.data.msg, {
          duration: 3500
        })
        // alert(err.response.data.msg)
      })
    },
    // 购买课程
    buy() {
      let commonUrl = '?goods_id=' + this.detail.course_id + '&payment_type=1&video_id=' + this.detail.video_ids + '&amount=' + this.detail.price + '&anchor=' + this.$route.path
      let wxUrl = 'index/index/pay/' + commonUrl
      let h5Url = 'index/index/pay/' + commonUrl + '&payment_platform=MWEB'
      let padUrl = 'index/index/qrpay/' + commonUrl
      // 获取设备类型
      // DEVICE_TYPE: wechat, h5, pad
      const DEVICE_TYPE = localStorage.getItem('device_type') || 'h5'
      let webDomain = localStorage.getItem('web_domain') || config.host
      if (DEVICE_TYPE === 'wechat') {
        window.location.href = webDomain + wxUrl
        console.log(webDomain + wxUrl)
      } else if (DEVICE_TYPE === 'h5') {
        window.location.href = webDomain + h5Url
        console.log(webDomain + h5Url)
      } else if (DEVICE_TYPE === 'pad') {
        window.location.href = webDomain + padUrl
        console.log(webDomain + padUrl)
      }
    },
    refreshScroll() {
      // setTimeout(() => {
      //   this.$refs.scroll.refresh()
      // }, 20)
    },
    setNavTitle(title) {
      this.navTitle = title
    },
    collect() {
      // 收藏课程
      if (this.collecting) return
      this.collecting = true
      collectCourse(this.detail.course_id).then(res => {
        let data = res.data
        if (data && data.code === RES_OK) {
          if (this.detail.is_collection) {
            this.$toast('取消收藏成功')
            this.showQrPopup = false
          } else {
            this.$toast('收藏成功')
            if (data.data.qrurl) {
              console.log('弹出关注二维码')
              this.qrurl = data.data.qrurl
              this.qrtext = '关注公众号, 不会错过老师上新课程'
              this.showQrPopup = true
            }
          }
          this.detail.is_collection = !this.detail.is_collection
        } else if (data && data.msg) {
          console.log(data.msg)
        }
        this.collecting = false
      })
    },
    goCert(cert) {
      // 已经购买 并且已经学完 就可以查看证书了
      this.$router.push({
        path: '/personal/certification/share',
        query: {
          url: cert
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .home{
    display flex
    width 100%
    height size(80)
    padding-left: size(30)
    padding-right: size(30)
    background-color: #333333
    flex-direction row
    flex-wrap nowrap
    align-items center
    color: #999999;
    span, a{
      font-size size(28)
      width 50%
      i{
        font-size: size(40)
        margin-right: size(6)
        position relative
        top: size(2)
      }
    }
    a{
      text-align right
      i{
        font-size: size(42)
        top: size(6)
      }
    }
  }
  .scroll
  .list-head
    min-height size(100)
    position relative
    img
      width 100%
      display block
    .title
      position absolute
      left 0
      bottom 0
      width 100%
      padding size(30)
      line-height 1
    .name
      font-size size(30)
      font-weight 800
      color #fff
      white-space nowrap
      overflow hidden
      text-overflow ellipsis

  .buy{
    z-index 9
    position fixed
    bottom: 0
    left 0
    width: 100%
    height: size(100)
    display block
    text-align center
    background #fff
    >div{
      display table
      width 100%
      height 100%
      .col{
        display table-cell
        // width: 50%
        vertical-align middle
      }
      .col-1{
        width percentage(270/750)
        color #fff
        font-size: size(32)
        background #333
        background linear-gradient(to left, #333, alpha(#333, .8))
        .iconfont{
          font-size size(38)
          position relative
          top 2px
        }
        .icon-yishoucang{
          color $color-theme
        }
      }
      .col-2{
        font-size size(32)
        color #fff
        background-color $color-theme
        background linear-gradient(to bottom right, $color-theme, alpha($color-theme, .65))
        &.disabled{
          opacity .5
        }
      }
    }
  }
  .buy:before{
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    height: 1px;
    content: '';
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    background-color: #e6e6e6;
  }
  .zhuan{
    position: fixed
    top size(150)
    right 0
    display block
    width 100%
    z-index 99
    >div{
      display block
      width 100%
      text-align right
      >div{
        background-color: $color-theme
        display table
        float right
        color #fff
        font-size: size(24)
        padding size(10)
        border-top-left-radius: size(40)
        border-bottom-left-radius: size(40)
        .col{
          display table-cell
          vertical-align middle
        }
        .col-1{
          .iconfont{
            font-size: size(35)
          }
        }
        .col-2{
          padding-left size(5)
        }
      }
    }
  }
  .big-title-wrap
    background #f9f8f8
    padding-bottom size(20)
  .big-title
    background #ffffff
    padding size(20) size(30) size(8)
    p
      font-size size(34)
      font-weight 700
      line-height size(52)
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 2
      -webkit-box-orient vertical
      word-wrap break-word
      word-break break-all
      span
        font-weight normal
        color #ffffff
        font-size 12px
        line-height 18px
        height 18px
        border-radius 8px
        padding 0 size(10)
        vertical-align middle
        position relative
        top -2px
        margin-right size(16)
        display inline-block
        background $color-theme
        background linear-gradient(to top right, $color-theme, lighten($color-theme, 30%))
    .price
      line-height size(72)
      .n,.f
        color #ff3125
        font-size size(36)
        font-weight 700
      .o
        font-size size(24)
        color #666
        position relative
        top size(-12)
      .f
        font-size size(34)
      .b
        font-size size(30)
        color #666
      .zan
        float right
        color #999
        font-size size(28)
        .iconfont
          font-size 15px
    .vip-label-1
      display inline-block
      width size(96)
      vertical-align middle
      position relative
      top -2px
  /*.nav2{
    position relative
    display table
    width 100%
    height size(90)
    padding-left: size(30)
    padding-right: size(30)
    .col{
      display table-cell
      vertical-align middle
      width 50%
    }
    .col-1{
      font-size size(34)
      text-align left
      color $color-text
      font-weight 600
    }
    .col-2{
      font-size size(28)
      text-align right
      span{
        display inline-block
        margin-left 8px
        i.shang{
          font-style normal
          font-weight 600
        }
      }
      span.active{
        color $color-theme
      }
    }
  }
  .nav2:before{
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    content: '';
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    background-color: #e6e6e6;
  }*/
  //大屏设备
  @media only screen and (min-width: 1280px) {
    .list-head img{
      height: size(450) !important
    }
  }
  .qr-popup{
    position relative
    z-index 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/systematic/systematic-detail.vue